"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Always import {h} from preact
var preact_1 = require("preact");
var Hero_1 = require("../components/Hero/Hero");
var targetNode = document.querySelector('.hero-section');
if (targetNode) {
    (0, preact_1.render)((0, preact_1.h)(Hero_1.default, null), targetNode);
}
